<template>
    <page
        v-if="finishedLoading"
        :busy="busy"
        :tabs="tabs"
        :regular-tabs="false"
        class="reservations-body"
        :right-button="rightButton"
        :rightButton2="rightButton2"
    >
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>
<script>
    import { mapGetters } from 'vuex';
    import Page from '../generic/page/page.vue';

    export default {
        name: 'Reservation',
        components: {
            Page,
        },
        mounted() {
            if (!isNaN(this.reservationId) && this.invoiceTitle == '...') {
                (async () => {
                    try {
                        await this.fetchReservationMetadata();
                    } finally {
                        if (this.reservationMetadata.is_quote) {
                            this.invoiceTitle = `Quote #${this.reservationId}`;
                        } else {
                            this.invoiceTitle = `Invoice #${this.reservationId}`;
                        }
                        this.finishedLoading = true;
                    }
                })();
            } else {
                this.finishedLoading = true;
            }
        },
        computed: {
            ...mapGetters('header', ['userPermissions']),
            ...mapGetters('reservation', ['reservationMetadata']),
            reservationId() {
                return parseInt(this.$route.params.id);
            },
            currentTab() {
                return this.tabs.findIndex((tab) => tab.active);
            },
            tabs() {
                if (!isNaN(this.reservationId)) {
                    return [
                        {
                            title: 'Details',
                            route: `/app/reservation/edit/details/${this.reservationId}`,
                            active: this.$route.path === `/app/reservation/edit/details/${this.reservationId}`,
                        },
                        {
                            title: this.invoiceTitle,
                            route: `/app/reservation/edit/invoice/${this.reservationId}`,
                            active: this.$route.path === `/app/reservation/edit/invoice/${this.reservationId}`,
                        },
                    ];
                } else {
                    return [
                        {
                            title: 'Details',
                            active: true,
                        },
                    ];
                }
                return [];
            },
            rightButton() {
                if (!this.reservationMetadata.is_quote) {
                    return {
                        variant: 'primary',
                        rotation: null,
                        text: '',
                        icon: 'comments',
                        callback: this.goToInbox,
                        visible: this.inboxLinkIsVisible,
                        bold: true,
                    };
                }
                return null;
            },
            rightButton2() {
                if (this.reservationMetadata.is_quote) {
                    return {
                        variant: 'primary',
                        rotation: null,
                        text: 'Unified Inbox',
                        icon: 'envelope',
                        callback: this.goToControlPanel,
                        visible: this.controlPanelIsVisible,
                        bold: true,
                    };
                }
                return {
                    variant: 'primary',
                    rotation: '90',
                    text: 'Control Panel',
                    icon: 'sliders',
                    callback: this.goToControlPanel,
                    visible: this.controlPanelIsVisible,
                    bold: true,
                };
            },
        },
        data() {
            return {
                finishedLoading: false,
                invoiceTitle: '...',
                busy: false,
            };
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
            async fetchReservationMetadata() {
                try {
                    await this.$store.dispatch('reservation/fetchReservationMetadata', { id: this.reservationId });
                } catch (err) {
                    this.errorToast({ text: 'Could not load reservation data.' });
                }
            },
            goToControlPanel() {
                window.location = `/app/reservation/invoice/${this.reservationId}/control-panel/`;
            },
            goToInbox() {
                window.location = this.reservationMetadata.conversation_url;
            },
            controlPanelIsVisible() {
                return !isNaN(this.reservationId);
            },
            inboxLinkIsVisible() {
                if (this.userPermissions != undefined) {
                    return this.controlPanelIsVisible() && this.userPermissions.can_view_inbox;
                }
                return false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(*) {
        font-family: 'Lato', sans-serif !important;
    }

    .reservations-body {
        background-color: #edf0f6 !important;
    }

    :deep(.custom-tabs) {
        background-color: #edf0f6 !important;
    }

    :deep(.nav-tabs .nav-link) {
        color: #3d3d3d;
    }

    :deep(.nav-tabs) {
        padding-top: 3px;
    }

    :deep(.nav-link.active) {
        color: #0d47a1 !important;
        font-weight: bold;
        background-color: inherit !important;
        border: 0 !important;
        border-width: 3px !important;
        border-color: #0d47a1 !important;
        border-bottom-style: solid !important;
    }

    :deep(.ag-body-horizontal-scroll) {
        min-height: 15px;
        height: 15px;
    }

    @media print {
        .lx-page-container {
            height: auto !important;
        }
    }
</style>
